/* Homepage-only progressive enhancement. No storage, tracking, cart or network calls. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-lili-home]').forEach(home => {
      if (home.dataset.llReady) return;
      home.dataset.llReady = 'true';
      const picker = home.querySelector('[data-ll-moment]');
      const destination = home.querySelector('[data-ll-moment-link]');
      const garment = home.querySelector('[data-ll-garment]');
      const localCollection = value => {
        try {
          const url = new URL(value, window.location.origin);
          return url.origin === window.location.origin && /^\/collections\/[^/]+\/?$/.test(url.pathname) ? url.pathname : null;
        } catch { return null; }
      };
      try {
        const source = home.querySelector('[data-ll-finder-data]');
        const moments = JSON.parse(source?.textContent || '[]').map(moment => ({...moment,choices:moment.choices.filter(choice => choice.count > 0 && localCollection(choice.url))})).filter(moment => moment.choices.length);
        if (moments.length && picker && garment && destination) {
          const option = (label,value) => { const node = document.createElement('option'); node.textContent = label; node.value = value; return node; };
          picker.replaceChildren(...moments.map(moment => option(moment.label,moment.id)));
          const syncResult = () => {
            const moment = moments.find(item => item.id === picker.value);
            const choice = moment?.choices.find(item => item.type === garment.value);
            if (!choice) return;
            destination.href = localCollection(choice.url);
            destination.textContent = `Explore ${choice.type === 'All styles' ? 'this moment' : choice.type.toLowerCase()} ↗`;
            home.querySelector('[data-ll-result-title]').textContent = moment.label;
            home.querySelector('[data-ll-result-note]').textContent = moment.description;
            home.querySelector('[data-ll-result-count]').textContent = `${choice.count} ${choice.count === 1 ? 'style' : 'styles'} to explore`;
            const preview = home.querySelector('[data-ll-result-image]');
            preview.hidden = !choice.image;
            if (choice.image) preview.src = choice.image;
            home.querySelectorAll('[data-ll-pick]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.llPick === moment.id)));
          };
          const syncMoment = () => {
            const moment = moments.find(item => item.id === picker.value);
            if (!moment) return;
            const previous = garment.value;
            garment.replaceChildren(...moment.choices.map(choice => option(choice.type,choice.type)));
            if (moment.choices.some(choice => choice.type === previous)) garment.value = previous;
            garment.disabled = moment.choices.length === 1;
            syncResult();
          };
          picker.addEventListener('change',syncMoment);
          garment.addEventListener('change',syncResult);
          home.querySelectorAll('[data-ll-pick]').forEach(button => {
            button.hidden = !moments.some(moment => moment.id === button.dataset.llPick);
            button.addEventListener('click',() => { picker.value = button.dataset.llPick; syncMoment(); });
          });
          syncMoment();
          home.querySelector('[data-ll-finder-controls]').hidden = false;
          home.querySelector('[data-ll-chips]').hidden = false;
          home.querySelector('[data-ll-finder-fallback]').hidden = true;
        }
      } catch { /* Server-rendered browse links remain usable if finder data is unavailable. */ }
      const pieces = Array.from(home.querySelectorAll('[data-ll-piece]'));
      const styleButtons = Array.from(home.querySelectorAll('[data-ll-style]'));
      if (pieces.length) {
        const chooseStyle = id => {
          pieces.forEach(piece => { piece.hidden = piece.dataset.llPiece !== id; });
          styleButtons.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.llStyle === id)));
        };
        styleButtons.forEach(button => {
          button.hidden = !pieces.some(piece => piece.dataset.llPiece === button.dataset.llStyle);
          button.addEventListener('click',() => chooseStyle(button.dataset.llStyle));
        });
        chooseStyle(pieces[0].dataset.llPiece);
        home.querySelector('[data-ll-style-controls]')?.removeAttribute('hidden');
      }
      const rail = home.querySelector('[data-ll-rail]');
      if (rail) {
        const controls = home.querySelector('[data-ll-controls]');
        const prev = home.querySelector('[data-ll-prev]');
        const next = home.querySelector('[data-ll-next]');
        controls?.removeAttribute('hidden');
        const syncButtons = () => {
          prev.disabled = rail.scrollLeft < 3;
          next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 3;
        };
        const move = direction => rail.scrollBy({left: direction * rail.clientWidth * 0.85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        prev?.addEventListener('click', () => move(-1));
        next?.addEventListener('click', () => move(1));
        rail.addEventListener('scroll', syncButtons, {passive:true});
        rail.addEventListener('keydown', event => {
          if (event.target !== rail) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
        });
        if ('ResizeObserver' in window) new ResizeObserver(syncButtons).observe(rail);
        syncButtons();
      }
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
